@import (reference) '../../../../constants/spacing.module.less';

.elements {
  width: 70%;
}

.footer-container {
  background-color: var(--white);
  border-top: 1px solid var(--grey-600);
  justify-content: start;
  padding: @space-16 @space-24;
}

@media (min-width: 1440px) {
  .elements {
    max-width: 1600px;
  }
}
